define(['Intl', './each.js', './is-object', '../extend.js', '../util/is-date.js', '../util/is-string.js', '../util/is-number.js'], function(Intl, each, isObject, extend, isDate, isString, isNumber) {
    var cache = {};
    var valueCache = {};

    var defaults = {
        nullString: '-'
    };

    var _essentialProps = ['year', 'month', 'day', 'hour', 'minute', 'second'];

    return {
        getFormatter: getDateFormatter
    };

    function _buildKeySegments(segments, options) {
        each(options, function(v, k) {
            segments.push(k);
            if (isObject(v)) {
                _buildKeySegments(segments, v);
            } else {
                segments.push(v);
            }
        });
    }

    //function parseFormatString(formatString) {
    //    var result = {};
    //    var parts = formatString.split('|');
    //    each(parts, function(part) {
    //        var segments = part.split(':');
    //        if (segments.length !== 2) {
    //            return;
    //        }
    //
    //        segments[0] = segments[0].trim();
    //        segments[1] = segments[1].trim();
    //
    //        switch (segments[0]) {
    //            case 'abbr':
    //                result.abbreviate = result.abbreviate || {};
    //                result.abbreviate.mode = segments[1];
    //                break;
    //            case 'dec':
    //                var fromTo = segments[1].split(',');
    //                result.minimumFractionDigits = parseInt(fromTo[0]);
    //                result.maximumFractionDigits = parseInt(fromTo[1]);
    //                break;
    //            case 'style':
    //            case 'currency':
    //            case 'currencyDisplay':
    //                result[segments[0]] = segments[1];
    //                break;
    //            default:
    //                throw new Error('Could not parse format string containing key: ' + segments[0]);
    //        }
    //    });
    //
    //    return result;
    //}

    function getDateFormatter(culture, options, formatAliases) {
        options = options || {};
        options = translateAlias(options, formatAliases);

        //if (options.formatString) {
        //    options = extend(true, {}, options, parseFormatString(options.formatString));
        //}

        var key = [];
        key.push(culture);
        _buildKeySegments(key, options);
        key = key.join('|');

        if (!cache[key]) {
            cache[key] = createFormatter(culture, options, formatAliases);
        }

        return cache[key];
    }

    function translateAlias(alias, formatAliases) {
        if (!isString(alias)) {
            return alias;
        }

        var result = formatAliases[alias];
        if (!result) {
            throw new Error('Could not find format alias: ' + alias);
        }

        return result;
    }

    function createFormatter(culture, options, formatAliases) {
        options = extend({}, defaults, options || {});

        // todo(slind): check options.culture if given?
        var _intlDateFormat = Intl.DateTimeFormat(culture, options);

        var cache = {};

        return {
            format: function format(value, optionOverrides) {
                if (optionOverrides && (isString(optionOverrides) || Object.keys(optionOverrides).length)) {
                    optionOverrides = translateAlias(optionOverrides, formatAliases);

                    var hasEssentialProp = false;

                    each(_essentialProps, function(prop) {
                        if (optionOverrides.hasOwnProperty(prop)) {
                            hasEssentialProp = true;
                        }
                    });

                    var opts;
                    if (hasEssentialProp === true) {
                        opts = optionOverrides;
                        if (!opts.nullString) {
                            opts.nullString = options.nullString;
                        }
                    } else {
                        opts = extend(true, {}, options, optionOverrides);
                    }

                    return getDateFormatter(opts.culture || culture, opts).format(value);
                }

                if (value == null) {
                    return options.nullString;
                }

                var cacheKey  = value ? value.toString() : 'null';
                if (cache[cacheKey]) {
                    return cache[cacheKey];
                }

                if (!isDate(value)) {
                    if (isString(value) || isNumber(value)) {
                        value = valueCache[value] = valueCache[value] || new Date(value);
                    } else {
                        return cache[cacheKey] = value;
                    }
                }

                var result = _intlDateFormat.format(value);

                cache[cacheKey] = result;

                return result;
            }
        };
    }
});



/*****************
 ** WEBPACK FOOTER
 ** ./components/core/src/js/util/intl-date-format.js
 ** module id = 101
 ** module chunks = 0
 **/